// @ts-strict-ignore
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import Profile from '../components/Profile'

const ProfileRoute: FC<RouteComponentProps> = props => <Profile {...props} />

export default WithContainerRoute(ProfileRoute)
